import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { CommonCPDLandingBanner } from './CommonCPDLandingBanner';
import { trackBannerClick, trackBannerShow } from './tracking';
import { useApplicationContext } from 'shared/utils/applicationContext';

const DEFAULT_URL = '/podobrat-kvartiru/?cian_source=listing_common_cpd_banner';

export const CommonCPDLandingBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const bannerUrl = config.get<string>('commonCPDLandingBanner.url') ?? DEFAULT_URL;

  const handleClick = React.useCallback(() => {
    window.open(bannerUrl, '_blank');
    trackBannerClick();
  }, [bannerUrl]);

  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <CommonCPDLandingBanner onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
